

function getItemsToShow() {
    return 1;
}

$(document).ready(function () {


    $('.component-intro-carousel').each(function () {

        const $component = $(this);

        $component.find('.carousel-item-container').each(function () {

            const $carousel = $(this);

            // Never initialize the same Slick instance twice.
            if ($carousel.hasClass('slick-initialized')) {
                return;
            }

            // Must have at least 2 direct children to be a carousel.
            if ($carousel.children().length < 2) {
                return;
            }

            $carousel.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                dots: false,
                adaptiveHeight: true,
                mobileFirst: false
            });

        });
    });



    $('.hero-carousel-section, .hero-carousel-image-section').each(function () {

        const $section = $(this);

        let $wrapper = $section.find('.hero-carousel-wrapper');

        if (!$wrapper.length) {
            $wrapper = $section.find('.hero-carousel-image-wrapper');
        }

        let $carousel = $wrapper.find('.hero-carousel');

        if (!$carousel.length) {
            $carousel = $wrapper.find('.hero-image-carousel');
        }

        if (!$carousel.length) {
            return;
        }

        // Critical: don't initialize Slick twice.
        if ($carousel.hasClass('slick-initialized')) {
            return;
        }

        const $leftArrow = $section.find('.left-arrow');
        const $rightArrow = $section.find('.right-arrow');
        const $dotsContainer = $section.find('.slider-dots-container');

        $section.attr('tabindex', '0');

        $carousel.slick({
            slidesToShow: getItemsToShow(),
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1118,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        const slick = $carousel.slick('getSlick');

        /*
         * Dots
         */
        if ($dotsContainer.length) {

            $dotsContainer.empty();

            for (let i = 0; i < slick.slideCount; i++) {
                $dotsContainer.append(
                    '<span class="dot" data-index="' + i + '"></span>'
                );
            }

            const $dots = $dotsContainer.find('.dot');

            $dots.first().addClass('active');

            $dots.on('click', function () {
                const targetIndex = parseInt($(this).attr('data-index'), 10);

                $carousel.slick('slickGoTo', targetIndex);
            });

            $carousel.on('afterChange', function (event, slick, currentSlide) {
                $dots.removeClass('active');
                $dots.eq(currentSlide).addClass('active');
            });
        }

        /*
         * Arrows
         */
        function updateArrowStates(currentSlide, slick) {

            const maxIndex = Math.max(
                0,
                slick.slideCount - slick.options.slidesToShow
            );

            const activeColor = '#8E9093';
            const inactiveColor = '#E6E7E8';

            if ($leftArrow.length) {
                if (currentSlide <= 0) {
                    $leftArrow.css('pointer-events', 'none');
                    $leftArrow.find('path').attr('fill', inactiveColor);
                } else {
                    $leftArrow.css('pointer-events', 'auto');
                    $leftArrow.find('path').attr('fill', activeColor);
                }
            }

            if ($rightArrow.length) {
                if (currentSlide >= maxIndex) {
                    $rightArrow.css('pointer-events', 'none');
                    $rightArrow.find('path').attr('fill', inactiveColor);
                } else {
                    $rightArrow.css('pointer-events', 'auto');
                    $rightArrow.find('path').attr('fill', activeColor);
                }
            }
        }

        updateArrowStates(0, slick);

        $carousel.on('afterChange', function (event, slick, currentSlide) {
            updateArrowStates(currentSlide, slick);
            $carousel.slick('setPosition');
        });

        if ($leftArrow.length) {
            $leftArrow.on('click', function () {
                $carousel.slick('slickPrev');
            });
        }

        if ($rightArrow.length) {
            $rightArrow.on('click', function () {
                $carousel.slick('slickNext');
            });
        }

        $section.on('keydown', function (e) {

            if (e.key === 'ArrowLeft') {
                $carousel.slick('slickPrev');
            }

            if (e.key === 'ArrowRight') {
                $carousel.slick('slickNext');
            }
        });

        /*
         * Recalculate position after images load.
         */
        $carousel.find('img').on('load', function () {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('setPosition');
            }
        });

        /*
         * Resize
         */
        $(window).on('resize', function () {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('setPosition');
            }
        });

    });

});
